import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';

import Loader from '../../Loader/Loader';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import messages from '../../../locale/jsonMessages';
import withStyles from 'isomorphic-style-loader/withStyles';

import submit from './submit';
import validate from './validate';

import cs from '../../../components/commonStyle.css';
import s from './ManageNotificationsForm.css';

const ManageNotificationsForm = (props) => {

	const { handleSubmit, submitting, loading, submit, intl: { formatMessage } } = props;


	const notificationRadioOption = [
		{ value: 'all', label: formatMessage(messages.all) },
		{ value: '2', label: formatMessage(messages.host) },
		{ value: '1', label: formatMessage(messages.guest) },
	];

	return (
		<form onSubmit={handleSubmit(submit)} className={s.manageNotificationsFormWrapper}>
			<div className='commonLabelText'>{formatMessage(messages.to)}:</div>
			<div className={cx('customRatioButton commonRadioBtnFlexGroup', cs.spaceBottom12)}>
				{notificationRadioOption.map((item, index) => (
					<label className='commonRadioFlex'>
						<Field
							name="to"
							component="input"
							type="radio"
							value={item.value}
						/>
						<span className='siteAdminRadioText'>{item.label}</span>
					</label>
				))}
			</div>

			<Field
				name="message"
				type="text"
				component={CommonFormComponent}
				componentClass="textarea"
				inputClass='commonTextAreaField'
				placeholder={formatMessage(messages.message)}
				labelText={formatMessage(messages.message)}
				isRequiredInput
			/>

			<div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
				<Loader
					type="button"
					label={formatMessage(messages.submit)}
					show={loading}
					buttonType="submit"
					disabled={submitting || loading}
					className={cx(cs.btnPrimary)}
				/>
			</div>

		</form>
	);
};

const mapState = (state) => ({
	loading: state?.loader?.sendNotification,
})

export default connect(mapState)(reduxForm({
	form: 'ManageNotificationsForm',
	onSubmit: submit,
	validate,
})(injectIntl(withStyles(cs, s)(ManageNotificationsForm))));
